export default __webpack_public_path__ + "static/media/caen4.1ae05848.jpg";